var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("default", function () {
        return [_c("div", [_vm._v("Название поля")])]
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mydates-wrap" },
        [
          _c(_setup.FunctionalCalendar, {
            ref: "cale",
            staticClass: "dates",
            attrs: {
              "is-modal": true,
              "is-date-range": true,
              "calendars-count": 2,
              "is-multiple": true,
              dateFormat: _setup.format,
              enabledDates: _setup.enabledDates,
              dayNames: _setup.dayNames,
              monthNames: _setup.monthNames,
              shortMonthNames: _setup.shortMonthNames,
              value: _setup.vals,
              isAutoCloseable: true,
            },
            on: { input: _setup.select, closed: _setup.closed },
            scopedSlots: _vm._u([
              {
                key: "dateRangeInputs",
                fn: function (props) {
                  return [
                    _c(
                      "div",
                      { staticClass: "start_end_text" },
                      [
                        _c(_setup.vCalendar, {
                          staticClass: "ico-calend vicon-black",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: {
                              empty: !props.startDate && !props.endDate,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _setup.start_end_text(
                                  props.startDate,
                                  props.endDate
                                )
                              )
                            ),
                            _c("span", { staticClass: "hi" }, [_vm._v("---")]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _setup.props.choosed[0]
            ? _c(
                "button",
                {
                  staticClass: "clear",
                  attrs: { title: "Сбросить" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _setup.clean.apply(null, arguments)
                    },
                  },
                },
                [_c(_setup.vRemove, { staticClass: "icon-red" })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }